import { Component, OnInit , ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { InterestpaymentsService } from "../../shared/interestpayments.service";
import { PrintpaymentreceiptsService } from "../../shared/printpaymentreceipts.service";

@Component({
  selector: 'app-interestpaymentslist',
  templateUrl: './interestpaymentslist.component.html',
  styleUrls: ['./interestpaymentslist.component.css']
})
export class InterestpaymentslistComponent implements OnInit {

  displayedColumns: string[] = ['Receipt No', 'Date', 'Customer','DepositNo', 'PrincipleAmount',  'Interest', 'TotalAmount', 'New'];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private interestpaymentsService: InterestpaymentsService, private paymentreceiptsService: PrintpaymentreceiptsService, 
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.getSavingsPaymentsList();
    this.dataSource.paginator = this.paginator;
  }

  getSavingsPaymentsList() {
    this.interestpaymentsService.FetchInterestPaymentsList()
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
        console.log(data);
      })
      .catch(err => { console.log(err) });
  }

  AddNewSavingsPayments() {
    this.router.navigate(['/interestpayments']);
  }

  EditSavingsPayments(savings: any) {
    this.router.navigate(['/interestpayments', savings.Id]);
  }

  PrintSavingsPaymentsReceipt(savings: any) {
    this.paymentreceiptsService.GetInterestpaymentsById(savings.Id);

    // this.router.navigate(['/savingsreceipt', savings.Id]);
  }
}
